export default Object.freeze({
  PrimerGrado11moGrado: 3
});
